"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/** @jsx jsx */

var core_1 = require("@emotion/core");

var icon_1 = __importStar(require("../icon/icon"));

var emotion_theming_1 = require("emotion-theming");

var styled_1 = __importDefault(require("../../../theme/styled"));

var PlayButton = styled_1["default"].button(function (_ref) {
  var sizePx = _ref.sizePx,
      sizePadding = _ref.sizePadding;
  return {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: sizePx,
    width: sizePx,
    padding: sizePadding,
    borderRadius: '50%',
    border: 0,
    position: 'relative',
    background: '#ffffff',
    cursor: 'pointer',
    boxShadow: '0 2px 4px 2px rgba(0, 0, 0, 0.2)',
    transition: 'transform 0.15s ease-out',
    '&:hover': {
      transform: 'scale(1.1)'
    }
  };
});
var IconContainer = styled_1["default"].div(function (_ref2) {
  var sizePositionHorz = _ref2.sizePositionHorz,
      sizePositionVert = _ref2.sizePositionVert;
  return {
    position: 'relative',
    left: sizePositionHorz,
    top: sizePositionVert
  };
});

var VideoPlayButton = function VideoPlayButton(_a) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? 'reg' : _a$size,
      rest = __rest(_a, ["size"]);

  var sizePx = '50px';
  var sizePadding = '15px';
  var sizePositionHorz = '2px';
  var sizePositionVert = '0';

  if (size === 'lg') {
    sizePx = '80px';
    sizePadding = '24px';
    sizePositionHorz = '5px';
    sizePositionVert = '-1px';
  } else if (size === 'sm') {
    sizePx = '40px';
    sizePadding = '12px';
    sizePositionHorz = '3px';
  }

  var theme = emotion_theming_1.useTheme();
  return core_1.jsx(PlayButton, Object.assign({
    sizePx: sizePx,
    sizePadding: sizePadding
  }, rest), core_1.jsx(IconContainer, {
    sizePositionHorz: sizePositionHorz,
    sizePositionVert: sizePositionVert
  }, core_1.jsx(icon_1["default"], {
    type: icon_1.IconType.Play,
    color: theme.colors.primary,
    sizing: "responsive"
  })));
};

exports["default"] = VideoPlayButton;